export class ItemMeasuresInfo {
  public measureType : string | undefined;
  public measureValue: string | undefined;
}
